export default defineNuxtPlugin((nuxtApp) => {
  if (process.env.NODE_ENV !== 'production') return;

  // Google Analytics 추적 ID
  const id = 'G-6BJSH9P2J4';

  const scriptTag = document.createElement('script');
  scriptTag.async = true;
  scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(scriptTag);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag('js', new Date());
  gtag('config', id);

  // 라우터 이동 시 페이지 추적
  const router = useRouter();
  router.afterEach(() => {
    gtag('config', id, {
      page_path: window.location.pathname,
    });
  });
});
